import { useContext } from "react";
import { HookOutOfContextError } from "@jugl-web/utils";
import { AIAssistantContext } from "./AIAssistantContext";

export const useAIAssistant = () => {
  const context = useContext(AIAssistantContext);

  if (!context) {
    throw new HookOutOfContextError("useAIAssistant", "AIAssistantContext");
  }

  return context;
};
